import React from "react";

const Tabs = ({ activeMetric, setActiveMetric, zoomRange, setZoomRange, setSelectedTreatmentIndex }) => {
  return (
    <div className="tabs">
      {["Heart Rate", "Weight", "BP", "PHQ-9 (Depression)", "GAD-7 (Anxiety)"].map((label) => (
        <div
          key={label}
          className={`tab ${activeMetric === label ? "active" : ""}`}
          onClick={() => setActiveMetric(label)}
        >
          {label}
        </div>
      ))}
      {zoomRange && (
        <button className="reset-zoom-button" onClick={() => {
          setSelectedTreatmentIndex(-1);
          setZoomRange(null)
        }}>
          Reset Zoom
        </button>
      )}
    </div>
  );
};

export default Tabs;
